// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3h5hH","unreadBadge":"styles_unreadBadge__2SE--","modalContent":"styles_modalContent__1eYkm","modal":"styles_modal__qaJhi"};